import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { OverlayModule } from '@angular/cdk/overlay';

import { MaterialsModule } from '@library/common/materials';
import { ErrorsModule } from '@library/modules/errors';

import { AddressbookRoutingModule } from './addressbook-routing.module';

import { AddressBookComponent } from './addressbook.component';
import { BusinessComponent } from './business';
import { ContactsComponent } from './contacts/contacts.component';

@NgModule({
   declarations: [
      AddressBookComponent,
      BusinessComponent,
      ContactsComponent,
   ],
   imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,

      OverlayModule,

      MaterialsModule,
      ErrorsModule,

      AddressbookRoutingModule,
   ],
})
export class AddressbookModule { }
